/* Stienhardt - diamond spec info tooltips (2026-06-27, BE-style)
   Adds a small (i) next to each Diamond-Specifications label; tap reveals a
   plain-English explanation. Revert = remove file + script. */
(function () {
  'use strict';
  var INFO = {
    'cut': "How the facets reflect light — the biggest driver of sparkle. Graded Excellent down to Poor.",
    'carat': "The diamond's weight, not its size. One carat equals 0.20 grams.",
    'color': "How colorless the diamond is, graded D (colorless) to Z. Nearer to D is whiter and rarer.",
    'clarity': "The absence of inclusions and blemishes, from Flawless (FL) to Included (I). Higher is cleaner.",
    'shape': "The diamond's outline — round, oval, cushion and more. A matter of style, not quality.",
    'l/w ratio': "Length divided by width — how elongated a fancy-shaped diamond appears.",
    'measurement': "The diamond's physical size in millimetres (length × width × depth).",
    'table': "The flat top facet as a percent of the diamond's width — shapes how light enters.",
    'depth': "The diamond's height as a percent of its width — affects brilliance and perceived size.",
    'polish': "The smoothness of the diamond's surface, graded Excellent to Poor.",
    'symmetry': "How precisely the facets align — finer symmetry means better light return.",
    'fluorescence': "Whether the diamond glows under UV light. Usually has no visible effect in daylight."
  };
  function key(t){ return (t || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  function closeAll(){ document.querySelectorAll('.sp-spec-pop.open').forEach(function (p){ p.classList.remove('open'); }); }
  function enhance(){
    document.querySelectorAll('.sp-stone-spec__label').forEach(function (lab){
      if (lab.querySelector('.sp-spec-info')) return;
      var copy = INFO[key(lab.textContent)];
      if (!copy) return;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'sp-spec-info';
      btn.setAttribute('aria-label', lab.textContent.trim() + ' — more info');
      btn.innerHTML = '<svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="8" cy="4.7" r="0.95" fill="currentColor"/><rect x="7.2" y="6.7" width="1.6" height="5" rx="0.8" fill="currentColor"/></svg>';
      var pop = document.createElement('span'); pop.className = 'sp-spec-pop'; pop.textContent = copy;
      btn.addEventListener('click', function (e){ e.stopPropagation(); var was = pop.classList.contains('open'); closeAll(); if (!was) pop.classList.add('open'); });
      lab.classList.add('sp-spec-has-info'); lab.appendChild(btn); lab.appendChild(pop);
    });
  }
  document.addEventListener('click', closeAll);
  var n = 0, iv = setInterval(function (){ n++; enhance(); if (n > 60) clearInterval(iv); }, 300);
  var mp = document.getElementById('mainproduct'); if (mp) new MutationObserver(enhance).observe(mp, { childList: true, subtree: true });
})();
